import { getState } from './state';
import { InitializationStatus, NotificationsState } from '../../types';
import { createSelector } from 'reselect';

const getInitializationStoreSlice = createSelector([getState], ncSlice => {
  return (
    ncSlice.initialization ??
    ({
      isReduxInitialized: InitializationStatus.Initializing,
      areTranslationsInitialized: InitializationStatus.Initializing,
      online: true,
      authInitializationAttempted: false,
    } as NotificationsState['initialization'])
  );
});

export const getIsReduxInitialized = createSelector(
  [getInitializationStoreSlice],
  initSlice => initSlice.isReduxInitialized === InitializationStatus.Success
);

export const getInitializationStatus = createSelector(
  [getInitializationStoreSlice],
  initSlice => {
    const initializationStatuses = Object.values(initSlice);
    if (
      initializationStatuses.length === 0 ||
      initializationStatuses.includes(InitializationStatus.Initializing)
    ) {
      return InitializationStatus.Initializing;
    } else if (initializationStatuses.includes(InitializationStatus.Failure)) {
      return InitializationStatus.Failure;
    }

    return InitializationStatus.Success;
  }
);
